export const getTraceIdFromResponse = (response: Response | undefined): string | null =>
	response?.headers?.get('x-b3-traceid') || response?.headers?.get('atl-traceid') || null;
